const cols = [
  {
    title: "栏目",
    links: ["今日热议", "人物深扒", "瓜田速报", "塌房时间线", "黑料合集", "深扒热度榜"],
  },
  {
    title: "黑料档案",
    links: ["顶流塌房档案", "言论翻车合集", "合约纠纷深度", "圈内考古串烧"],
  },
  {
    title: "关于我们",
    links: ["站点介绍", "爆料投稿", "内容规范", "转载合作", "免责声明"],
  },
];

const legal = ["关于我们", "投稿须知", "隐私政策", "版权声明", "商务合作", "联系我们"];

export default function Footer() {
  return (
    <footer className="border-t border-foreground-200/70 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <a href="#top" className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-foreground-50">
                <i className="ri-eye-2-line text-2xl" />
              </span>
              <span className="font-heading text-2xl font-black text-foreground-950">网曝网</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注深扒与黑料合集的独立站点，把塌房、黑历史与负面素材整理成可检索、可回放的档案。
            </p>
            <div className="mt-5 flex items-center gap-2 text-foreground-600">
              <span className="inline-flex items-center gap-1 rounded bg-background-50 px-2.5 py-1.5 text-xs">
                <i className="ri-error-warning-line text-primary-600" /> 仅为信息汇编，不做定论
              </span>
            </div>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="mb-4 text-sm font-bold text-foreground-950">{c.title}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l}>
                    <a href="#top" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-foreground-200/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <ul className="flex flex-wrap gap-x-5 gap-y-2">
            {legal.map((l) => (
              <li key={l}>
                <a href="#top" className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600">
                  {l}
                </a>
              </li>
            ))}
          </ul>
          <p className="whitespace-nowrap text-xs text-foreground-500">© 2026 网曝网 · 资讯汇总平台</p>
        </div>
      </div>
    </footer>
  );
}